import React from "react";
import { useStyles } from "./style";
import { Container, Grid } from "@material-ui/core";
import { Link } from "gatsby";
import Logo from "../../../images/logo.png";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import "./style.css";
import SearchInput from "../../searchInput";

export default function MobileNavbar({ handelMenu, isMenuOpen }) {
  const classes = useStyles();

  const [isSearch, setIsSearch] = React.useState(false);
  const [isDarkMode, setDarkMode] = React.useState(false);
  return (
    <header
      className={`${classes.root} ${classes.header}`}
      style={{
        display: isMenuOpen ? "block" : "none",
        backgroundImage: isDarkMode && "linear-gradient(#000 0%, #ffe6b7 100%)",
      }}
    >
      <div className={classes.mainHeader}>
        <Container>
          <Grid container>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <div className={classes.mobileAction}>
                <SearchIcon
                  style={{ fontSize: 35, color: isDarkMode ? "#fff" : "#000" }}
                  onClick={() => setIsSearch(!isSearch)}
                />
              </div>
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Link className={classes.headerLogoAnchor} to="/">
                  <img src={Logo} className={classes.headerLogo} alt="" />
                </Link>
              </div>
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <div
                className={classes.mobileAction}
                style={{ justifyContent: "flex-end" }}
              >
                <CloseIcon
                  style={{ fontSize: 35, color: isDarkMode ? "#fff" : "#000" }}
                  onClick={handelMenu}
                />
              </div>
            </Grid>
          </Grid>
          <div className={classes.mobileMenu}>
            <div
              style={{
                maxWidth: 250,
                marginTop: 15,
                marginBottom: 15,
                background: isDarkMode ? "#fff" : "transparent",
                borderRadius: 11,
              }}
            >
              {isSearch && (
                <SearchInput classes={classes} />
              )}
            </div>
            <div>
              <div
                style={{
                  display: "block",
                  borderBottom: "1px solid rgba(248, 177, 149, .47)",
                  height: "100%",
                }}
              >
                <div>
                  <Link
                    to="#"
                    className={classes.primaryMenuLink}
                    style={{
                      fontWeight: 700,
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    Read
                  </Link>
                </div>
                <div className={classes.subMenu}>
                  <Grid container>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/features"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Features
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/look"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Look
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/face"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Face
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/sex-and-dating"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Sex
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/body"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Body
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/real-life"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Real Life
                      </Link>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Link
                        to="/blog/hair"
                        style={{
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        Hair
                      </Link>
                    </Grid>
                  </Grid>
                </div>
              </div>
              <div
                className={classes.subMenu}
                style={{
                  paddingTop: 2.5,
                  paddingBottom: 2.5,
                  borderBottom: "1px solid rgba(248, 177, 149, .47)",
                }}
              >
                <Link
                  to="/reviews"
                  style={{
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Reviews
                </Link>
              </div>
              {/* <div
                className={classes.subMenu}
                style={{
                  paddingTop: 2.5,
                  paddingBottom: 2.5,
                  borderBottom: "1px solid rgba(248, 177, 149, .47)",
                }}
              >
                <Link
                  to="/"
                  style={{
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Create
                </Link>
              </div> */}
              <div
                className={classes.subMenu}
                style={{
                  paddingTop: 2.5,
                  paddingBottom: 2.5,
                  borderBottom: "1px solid rgba(248, 177, 149, .47)",
                }}
              >
                <Link
                  to="/"
                  style={{
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Shop
                </Link>
              </div>
              <div className={classes.darkModeContainer}>
                <div className={classes.darkModeStatus}>
                  <img
                    src={
                      !isDarkMode
                        ? "https://verygoodlight.com/wp-content/uploads/2020/06/night-mode.svg"
                        : "https://verygoodlight.com/wp-content/uploads/2020/06/night-mode-activated.svg"
                    }
                    alt="Dark Mode"
                  />
                  <span
                    style={{
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    Dark Mode
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    className="apple-switch"
                    type="checkbox"
                    value={isDarkMode}
                    onChange={(e) => setDarkMode(e.target.checked)}
                  />
                </div>
              </div>
              <div className={classes.socialPageContainer}>
                <div>
                  <Link
                    to="/"
                    style={{
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    <FacebookIcon />
                  </Link>
                  <Link
                    to="/"
                    style={{
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    <InstagramIcon />
                  </Link>
                  <Link
                    to="/"
                    style={{
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    <YouTubeIcon />
                  </Link>
                  <Link
                    to="/"
                    style={{
                      color: isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    <TwitterIcon />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </header>
  );
}
